import React, { Component } from "react";
import MobileHeaderBack from "../../MobileHeaderBack/index";
import { subscriptionOrderDetails } from '../../../../shared/lib/subscriptionService';

class CardInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardDigits: ["", "", "", ""], // 4 boxes
      disableBtn: true,
    };

    this.inputRefs = [];
  }

  handleInputChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // allow only numbers

    const updatedDigits = [...this.state.cardDigits];
    updatedDigits[index] = value.slice(0, 4);

    this.setState(
      {
        cardDigits: updatedDigits,
        disableBtn: updatedDigits.some((d) => d.length !== 4),
      },
      () => {
        if (value.length === 4 && this.inputRefs[index + 1]) {
          this.inputRefs[index + 1].focus();
        }
      }
    );
  };

  handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.cardDigits[index] && this.inputRefs[index - 1]) {
      this.inputRefs[index - 1].focus();
    }
  };

  handleSubmit = () => {
    const cardNumber = this.state.cardDigits.join("");

    const params = new URLSearchParams(window.location.search);

    const visaId = params.get("visaId");
    const aliasId = params.get("aliasId");

    if (visaId && aliasId) {
      this.getBookingDetails(visaId, aliasId);
    }

    // keep your existing submit logic
    // const params = new URLSearchParams(window.location.search);

    // const page = params.get("page");
    // const visaId = params.get("visaId");
    // const aliasId = params.get("aliasId");

    // if (page === "checkout") {
    //   const checkoutURL = sessionStorage.getItem("checkoutURL");
    //   window.location.href = checkoutURL || "/";
    // } else if (visaId && aliasId) {
    //   this.getBookingDetails(visaId, aliasId);
    // }
  };

  getBookingDetails = async (id, alId) => {
    const site_id = this.props?.pageInfo?.site?.id;
    const access_token = this.props?.userToken || "";
    const order_token = id;
    const aliasId = alId;
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page");

    try {
      const res = await subscriptionOrderDetails({
        site_id,
        access_token,
        order_token,
        aliasId
      });

      if (res?.status) {
        this.props.setCardData(res?.data?.data);
        if (page === "checkout") {
          const checkoutURL = sessionStorage.getItem("checkoutURL");
          window.location.href = checkoutURL
        } else {
          this.props.setSuccess(true);
        }

      }
    } catch (error) {
      console.error("Error occurred while fetching booking details", error);
    }
  };

  render() {
    const { isMobile, redirectPath = "/activity/details", styles, mobileHeaderStyle } = this.props;

    return (
      <div className={styles.visa_component}>
        {isMobile && (
          <MobileHeaderBack
            themeColor="white"
            styles={mobileHeaderStyle}
            path={redirectPath}
            themeType="white"
          />
        )}

        <div className={styles.visa_component__card}>
          <div className={styles.visa_component__instruction}>
            Enter your 16 digit Visa card number to activate BB-Pro membership
          </div>

          {/* Card Input Boxes */}
          <div className={styles.visa_component__input_section}>
            {this.state.cardDigits.map((value, index) => (
              <input
                key={index}
                ref={(el) => (this.inputRefs[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength={4}
                value={value}
                onChange={(e) => this.handleInputChange(index, e.target.value)}
                onKeyDown={(e) => this.handleKeyDown(index, e)}
                className={styles.visa_component__input_group}
                // placeholder="••••"
              />
            ))}

          </div>
        </div>
        {/* Submit Button */}
        <div className={styles.visa_component__actions}>
          <div className={styles.visa_component__button_container}>
            <button
              className={styles.visa_component__submit_button}
              onClick={this.handleSubmit}
              disabled={this.state.disableBtn}
              type="button"
            >
              <span className={styles.visa_component__submit_text}>Submit</span>
            </button>
          </div>
          <div className={styles.visa_component__disclaimer}>
            <p className={styles.visa_component__disclaimer_text}>
              * This membership is completely free, and no charges will be applied to your Visa
              card.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CardInputComponent;
